import { render, staticRenderFns } from "./OptimizationForm.vue?vue&type=template&id=08d08745&scoped=true"
import script from "./OptimizationForm.vue?vue&type=script&lang=js"
export * from "./OptimizationForm.vue?vue&type=script&lang=js"
import style0 from "./OptimizationForm.vue?vue&type=style&index=0&id=08d08745&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d08745",
  null
  
)

export default component.exports